import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import {
  get_module_entity_action_middleware,
  post_module_entity_action_middleware,
  put_module_entity_action_middleware,
  delete_module_entity_action_middleware,
} from "services/middleware_services"
import Swal from "sweetalert2"

interface IGetLocationParams {
  location_id: string
  params?: any
}

interface IPostLocationParams {
  body: any
}

const useLocationsResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const get_location_action = async ({ location_id, params = {} }: IGetLocationParams) => {
    try {
      return await get_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `locations/${location_id}`,
        params,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const post_get_list_location_action = async ({ body }: IPostLocationParams) => {
    try {
      return await get_module_entity_action_middleware(OMNIX_MODULE.OLM, `locations`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const post_filter_location_action = async ({ body }: IPostLocationParams) => {
    try {
      return await post_module_entity_action_middleware(OMNIX_MODULE.OLM, `locations/all`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const put_upsert_location_action = async ({ body }: IPostLocationParams) => {
    try {
      return await put_module_entity_action_middleware(OMNIX_MODULE.OLM, `locations`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  const delete_location_action = async ({ body }: IPostLocationParams) => {
    try {
      return await delete_module_entity_action_middleware(OMNIX_MODULE.OLM, `locations`, body, token, newCancelToken())
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    get_location_action,
    post_filter_location_action,
    post_get_list_location_action,
    put_upsert_location_action,
    delete_location_action,
    loading_app,
    set_loading_app,
  }
}

export default useLocationsResources
